import React from 'react';
import AriesButton from './AriesButton';

/**
 * AriesSecondaryButton — outlined pill. Inherits AriesButton behavior and
 * locks the `secondary` variant.
 */
const AriesSecondaryButton = (props) => (
  <AriesButton {...props} variant="secondary" />
);

export default AriesSecondaryButton;
